/**
 * Saudi National Day 96 (Wednesday 23 September 2026) — one switch for every
 * seasonal surface in the app and on hotel booking sites.
 *
 * Window: 16–26 September 2026, Riyadh time (a week of run-up, then the holiday and the days after). `NEXT_PUBLIC_NATIONAL_DAY_96`
 * overrides it (`on` / `off`); unset follows the calendar. Components never
 * compare dates themselves — they ask `isNationalDayActive()`.
 */
export const NATIONAL_DAY_96 = {
  start: '2026-09-16',
  end: '2026-09-26',
  day: '2026-09-23',
  timeZone: 'Asia/Riyadh',
  /** Booking-site seasonal theme key already understood by SeasonalDecorations. */
  theme: 'national_day',
} as const

/** Riyadh calendar date as `YYYY-MM-DD` (en-CA gives the ISO order). */
export function riyadhDate(now: Date = new Date()): string {
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: NATIONAL_DAY_96.timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(now)
}

export function isNationalDayActive(now: Date = new Date()): boolean {
  const override = (process.env.NEXT_PUBLIC_NATIONAL_DAY_96 ?? '').trim().toLowerCase()
  if (override === 'on') return true
  if (override === 'off') return false
  const d = riyadhDate(now)
  return d >= NATIONAL_DAY_96.start && d <= NATIONAL_DAY_96.end
}

/**
 * Booking sites: a hotel's own `seasonal_theme` always wins. With none set,
 * National Day week switches the national_day theme on for every hotel and
 * off again afterwards, so nobody has to remember to toggle it.
 */
export function effectiveSeasonalTheme(tenantTheme: string | null | undefined, now: Date = new Date()): string | null {
  if (tenantTheme) return tenantTheme
  return isNationalDayActive(now) ? NATIONAL_DAY_96.theme : null
}
